import { WorkflowStepType } from '@commenda/types/src/workflow';
import { TRIGGER_NODE_TYPE } from '../types/node';
import { AgentNode } from './AgentNode';
import { ApiCallNode } from './ApiCallNode';
import { DemoAIFillingAgentNode } from './DemoAIFillingAgentNode';
import { DemoEmailNode, EmailNode } from './EmailNode';
import { EndNode } from './EndNode';
import { EsignNode } from './EsignNode';
import { ExclusiveSplitGatewayNode } from './ExclusiveSplitGatewayNode';
import { HumanFormNode } from './HumanFormNode';
import { HumanNode } from './HumanNode';
import { HumanReviewNode } from './HumanReviewNode';
import { InclusiveSplitGatewayNode } from './InclusiveSplitGatewayNode';
import { JoinNode } from './JoinNode';
import { LLMNode } from './LLMNode';
import { ParallelSplitNode } from './ParallelSplitNode';
import { RedirectNode } from './RedirectNode';
import { RootfiSyncNode } from './RootfiSyncNode';
import { StartNode } from './StartNode';
import { SubWorkflowNode } from './SubWorkflowNode';
import { ToolCallNode } from './ToolCallNode';
import { TriggerNode } from './TriggerNode';
import { WatchJobNode } from './WatchJobNode';

export const nodeTypes = {
  [WorkflowStepType.START]: StartNode,
  [WorkflowStepType.END]: EndNode,
  [WorkflowStepType.HUMAN_CONFIRM]: HumanNode,
  [WorkflowStepType.HUMAN_FORM]: HumanFormNode,
  [WorkflowStepType.HUMAN_REDIRECT]: RedirectNode,
  [WorkflowStepType.SYS_API_CALL]: ApiCallNode,
  [WorkflowStepType.SYS_AI_AGENT]: AgentNode,
  [WorkflowStepType.SYS_WATCH_JOB]: WatchJobNode,
  [WorkflowStepType.SYS_ROOTFI_SYNC]: RootfiSyncNode,
  [WorkflowStepType.SYS_SUB_WORKFLOW]: SubWorkflowNode,
  [WorkflowStepType.GATEWAY_PARALLEL_SPLIT]: ParallelSplitNode,
  [WorkflowStepType.GATEWAY_PARALLEL_JOIN]: JoinNode,
  [WorkflowStepType.GATEWAY_BOOLEAN_EXCLUSIVE_SPLIT]: ExclusiveSplitGatewayNode,
  [WorkflowStepType.GATEWAY_INCLUSIVE_SPLIT]: InclusiveSplitGatewayNode,
  [WorkflowStepType.SYS_LLM]: LLMNode,
  [WorkflowStepType.SYS_EMAIL]: EmailNode,
  [WorkflowStepType.DEMO_AI_FILLING_AGENT]: DemoAIFillingAgentNode,
  [WorkflowStepType.SYS_TOOL_CALL]: ToolCallNode,
  [WorkflowStepType.DEMO_EMAIL]: DemoEmailNode,
  [WorkflowStepType.HUMAN_REVIEW]: HumanReviewNode,
  [WorkflowStepType.HUMAN_ESIGN]: EsignNode,
  [TRIGGER_NODE_TYPE]: TriggerNode,
};
